import { createAction } from 'redux-actions'

export const getReferralConfigStart = createAction('GET_REFERRAL_CONFIG_START')
export const getReferralConfigFail = createAction('GET_REFERRAL_CONFIG_FAIL')
export const getReferralConfigSuccess = createAction(
  'GET_REFERRAL_CONFIG_SUCCESS'
)
